import card_1 from './assets/card-1.png';
import card_2 from './assets/card-2.png';
import card_3 from './assets/card-3.png';
import card_4 from './assets/card-4.png';
import card1_1 from './assets/card1_1.svg';
import card1_3 from './assets/card1_3.svg';
import card1_4 from './assets/card1_4.svg';
import card1_5 from './assets/card1_5.svg';
import card1_6 from './assets/card1_6.svg';
import card1_7 from './assets/card1_7.svg';
import card1_8 from './assets/card1_8.svg';
import card3_3 from './assets/card3_3.svg';
import card3_4 from './assets/card3_4.svg';
import card3_5 from './assets/card3_5.svg';
import card4_3 from './assets/card4_3.svg';
import card4_4 from './assets/card4_4.svg';
import card4_5 from './assets/card4_5.svg';
import card4_7 from './assets/card4_7.svg';
import card4_9 from './assets/card4_9.svg';
import card4_11 from './assets/card4_11.svg';

export default {
  'card-1.png': card_1,
  'card-2.png': card_2,
  'card-3.png': card_3,
  'card-4.png': card_4,
  'card1_1.svg': card1_1,
  'card1_3.svg': card1_3,
  'card1_4.svg': card1_4,
  'card1_5.svg': card1_5,
  'card1_6.svg': card1_6,
  'card1_7.svg': card1_7,
  'card1_8.svg': card1_8,
  'card3_3.svg': card3_3,
  'card3_4.svg': card3_4,
  'card3_5.svg': card3_5,
  'card4_3.svg': card4_3,
  'card4_4.svg': card4_4,
  'card4_5.svg': card4_5,
  'card4_7.svg': card4_7,
  'card4_9.svg': card4_9,
  'card4_11.svg': card4_11,
};
